<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaProdus')}}</h4>
        </div>
        <form class="add-user-form" id='edit-product' method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                        <div class="selections-option" v-if="input_field.inputName == 'nivel1'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel1')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_category" @input="getSubcategoriesFromCategory()" @change="calculateFinalPrice('category')" :options="categories" label="name"></v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName == 'nivel2'" @click="selected_label = 2">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel2')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_subcategory" @input="getSubcategoriesSubtypes()" @change="calculateFinalPrice('subcategory')" :options="subcategories" label="name"></v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName == 'nivel3'" @click="selected_label = 2">
                            <label :class="{select_label_class:selected_label === 1}"> {{$t('placeholder.alegeNivel3')}} </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label === 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_subtype" :options="subtypes" label="name" @change="calculateFinalPrice('subtype')"></v-select>
                        </div>
                        <div v-else>
                            <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :name="input_field.inputName"
                                   v-model="input_field.inputValue"
                                   :data-vv-as="input_field.labelName"
                                   :id="input_field.inputName"
                                   @input="calculateFinalPrice(input_field.inputName)"
                                   @change="calculateFinalPrice(input_field.inputName)">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                            <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                        </div>
                    </div>
                    <div v-if="products">
                      <div class="form-group"
                           v-for="priceCat in priceCategoryes"
                           :key="priceCat.value">
                            <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="priceCat.validationRules"
                                   :data-vv-as="priceCat.display"
                                   v-bind:name="priceCat.addition"
                                   v-bind:id="priceCat.addition"
                                   v-model="products.additions[priceCat.addition]"
                                   @input="calculateFinalPrice('addition_inputs')"
                                   @change="calculateFinalPrice('addition_inputs')">
                            <label class=""> Adaos {{priceCat.display}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i class="fas fa-percentage"></i>
                            </span>
                             <p class="custom-error-info"> {{errors.first(priceCat.addition)}} </p>
                      </div>
                      <div class="form-group">
                        <div class="selections-option">
                          <label class=""> Producator  </label>
                          <v-select :options="manufacturers" v-model="manufacturer" label="name" placeholder="Alege Producator">
                          </v-select>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName"
                               v-model="input_field.inputValue"
                               @input="calculateFinalPrice(input_field.inputName)"
                               @change="calculateFinalPrice(input_field.inputName)">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                    <div v-if="products">
                      <div class="form-group"
                          v-for="priceCat in priceCategoryes"
                          :key="priceCat.value">
                          <input type="text" class="form-control"
                                  placeholder=""
                                  v-validate="priceCat.validationRules"
                                  :data-vv-as="priceCat.display"
                                  v-bind:name="priceCat.name"
                                  v-bind:id="priceCat.name"
                                  v-model="products.prices[priceCat.name]"
                                  @input="calculateFinalPrice('price_inputs')"
                                  @change="calculateFinalPrice('price_inputs')">
                          <label class=""> Pret {{priceCat.display}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                            <i class="fas fa-tags"></i>
                          </span>
                          <p class="custom-error-info"> {{errors.first(priceCat.name)}} </p>
                      </div>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-12">
                  <div class="doc-group">
                    <div class="template-section-heading">
                        <h4> Incarca imagini </h4>
                    </div>
                      <b-form-file
                              @change="onFileChange"
                              name="files[]"
                              v-model="file"
                              ref="file-input"
                              :state="Boolean(file)"
                              :placeholder="$t('placeholder.dropFilesHere')"
                              :drop-placeholder="$t('placeholder.dropFilesHere')"
                              multiple
                      ></b-form-file>
                      <div class="template-img-wrapper" v-if="url.img">
                        <div class="template-img-preview" v-for="(file, index) in url.img" :key="file.id">
                            <img :src="file.link" alt="product-image">
                            <div @click="removeMedia(index , file.id)" class="remove-product-image">
                              <i class="fas fa-times"></i>
                            </div>
                        </div>
                      </div>
                      <!--<div class="reset-files-wrapper" v-if="file">
                          <b-button @click="clearFiles" class="reset-files-button"> {{$t('txt.eliminaFisiereleIncarcate')}}
                          </b-button>
                      </div>-->
                  </div>
                </div>
                <div class="col-12">
                    <div class="template-section-heading">
                        <h4> Descriere produs </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea name='description' v-model="description">  </textarea>
                        <div class="save-contact-buttons">
                            <button type="button" @click='editProduct()'>
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Level1Service from '../../api-services/nivel1.service.js'
import Level2Service from '../../api-services/nivel2.service.js'
import ProductsService from '../../api-services/products.service.js'
export default {
  name: 'editproduct',
  data () {
    return {
      url: {
        img: [ ]
      },
      file: null,
      products: [],
      subtypes: [],
      subcategories: [],
      categories: [],
      priceCategoryes: null,
      select_category: null,
      select_subcategory: null,
      selected_label: null,
      select_subtype: null,
      description: null,
      imagesFromDB: 0,
      rerenderRow: 0,
      manufacturer: null,
      manufacturers: []
    }
  },
  methods: {
    removeMedia (index, mediaId) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeFisierul'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          let target = document.querySelector('.custom-file-label')
          let targetText = target.innerHTML
          let parts = targetText.split(',')
          parts.splice(index - 1, 1)
          let outputText = ''
          if (parts.length === 1) {
            outputText = parts.join('')
          } else {
            outputText = parts.join(',')
          }
          target.innerHTML = outputText
          ProductsService.deleteMedia(mediaId)
            .then((response) => {
              this.$delete(this.url.img, index)
              this.$notify({
                group: 'succes',
                type: 'success',
                title: 'DELETED',
                text: 'Fisiserul a fost stears cu succes!',
                'animation-type': 'css'
              })
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    onFileChange (e) {
      const file = e.target.files
      let vm = this
      for (let i = 0; i < file.length; i++) {
        vm.url.img.push({
          link: URL.createObjectURL(file[i]),
          index: i + 1
        })
      }
    },
    clearFiles (index = '') {
      if (index !== '') {
        console.log(this.imagesFromDB, 'this.imagesFromDB')
        console.log(index, 'index')
        this.$delete(this.url.img, this.imagesFromDB + index - 1)
      } else {
        this.url.img = []
      }
    },
    calculateFinalPrice (target) {
      let fields = ['addition_inputs', 'category', 'subcategory', 'subtype', 'cost_acquisition']
      if (fields.includes(target)) {
        let costAcquisition = parseFloat(document.getElementsByName('cost_acquisition')[0].value).toFixed(2)
        costAcquisition = costAcquisition > 0 ? costAcquisition : 0

        let vm = this
        this.priceCategoryes.forEach(function (priceCat) {
          let priceCatAddition = parseFloat(vm.getAddition(priceCat.addition))
          vm.products.prices[priceCat.name] = parseFloat(parseFloat(costAcquisition) + ((parseFloat(priceCatAddition) / 100) * parseFloat(costAcquisition))).toFixed(2)
          vm.products.prices[priceCat.name] = parseFloat(vm.products.prices[priceCat.name]) > 0 ? parseFloat(vm.products.prices[priceCat.name]) : 0
        })
      }
    },
    getAddition (param) {
      let output = parseFloat(document.getElementsByName(param)[0].value)
      output = output >= 0 ? output : null
      this.products[param] = output
      if (output >= 0 && output != null) {
        return output
      }
      if (this.select_subtype) {
        if (this.select_subtype[param] != null) {
          return this.select_subtype[param]
        }
      }
      if (this.select_subcategory) {
        if (this.select_subcategory[param] != null) {
          return this.select_subcategory[param]
        }
      }
      if (this.select_category) {
        if (this.select_category[param] != null) {
          return this.select_category[param]
        }
      }
      return null
    },
    getProduct () {
      return new Promise((resolve, reject) => {
        ProductsService.get(this.$route.params.id)
          .then((response) => {
            this.products = response.data.data
            let addit = []
            let vm = this
            this.priceCategoryes.forEach(function (priceCat) {
              addit[priceCat.addition] = Number.parseFloat((_.cloneDeep(vm.products.prices[priceCat.name]) - _.cloneDeep(vm.products.cost_acquisition)) / _.cloneDeep(vm.products.cost_acquisition) * 100).toFixed(2)
            })
            this.products.additions = addit
            this.description = response.data.data.description
            this.url.img = response.data.data.files
            this.imagesFromDB = this.url.img.length
            this.$store.dispatch('hideLoading')
            this.getCategories()
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    async getManufacturers () {
      await ProductsService.getManufacturers()
        .then((response) => {
          this.manufacturers = response.data.data.data
          this.manufacturer = this.manufacturers.find(mnf => parseInt(mnf.id) === parseInt(this.products.manufacturer.id))
        })
        .catch((error) => {
          console.log(error)
          this.getManufacturers()
        })
    },
    getCategories () {
      Level1Service.getAll().then((response) => {
        this.categories = response.data.data
        this.select_category = this.categories.find(category => category.id === this.products.nivel1.id)
        this.$store.dispatch('hideLoading')
        this.getSubcategoriesFromCategory()
      }).catch((error) => {
        console.log(error)
        this.$store.dispatch('hideLoading')
      })
    },
    getSubcategoriesFromCategory () {
      let categoryId = (this.select_category) ? this.select_category.id : null
      this.subcategories = []
      if (categoryId > 0) {
        Level1Service.get(categoryId)
          .then((response) => {
            this.subcategories = response.data.data.nivel2
            if (this.products.nivel2) {
              this.select_subcategory = this.subcategories.find(subcategory => subcategory.id === this.products.nivel2.id)
              if (this.select_subcategory) {
                this.getSubcategoriesSubtypes()
              }
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    getSubcategoriesSubtypes () {
      let subcategoryId = (this.select_subcategory) ? this.select_subcategory.id : null
      this.subtypes = []
      if (subcategoryId > 0) {
        Level2Service.get(subcategoryId)
          .then((response) => {
            this.subtypes = response.data.data.nivel3
            this.select_subtype = this.subtypes.find(subtype => subtype.id === this.products.nivel3.id)
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    editProduct () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-product'))
      if (this.select_category) {
        formData.append('nivel1', this.select_category.id)
      }
      if (this.select_subcategory) {
        formData.append('nivel2', this.select_subcategory.id)
      }
      if (this.select_subtype) {
        formData.append('nivel3', this.select_subtype.id)
      }
      if (this.manufacturer) {
        formData.append('manufacturer', this.manufacturer.id)
      }

      ProductsService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.level1 = response.data.data
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.produsModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.products) ? this.products.ord : null,
            icon: 'fas fa-sort-numeric-up'
          },
          {
            inputName: 'nivel1',
            labelName: this.$t('placeholder.categorie'),
            inputValue: (this.products && this.products.nivel1) ? this.products.nivel1.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'nivel2',
            labelName: this.$t('placeholder.subcategorie'),
            inputValue: (this.products && this.products.nivel2) ? this.products.nivel2.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'nivel3',
            labelName: this.$t('placeholder.subtip'),
            inputValue: (this.products && this.products.nivel3) ? this.products.nivel3.name : null,
            icon: 'fas fa-file-signature'
          }
        ],
        column_2: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumire'),
            inputValue: (this.products) ? this.products.name : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'stoc',
            labelName: this.$t('placeholder.stoc'),
            inputValue: (this.products) ? this.products.stoc : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'cost_acquisition',
            labelName: this.$t('placeholder.costAchizitie'),
            inputValue: (this.products) ? this.products.cost_acquisition : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'discount',
            labelName: this.$t('placeholder.discount'),
            inputValue: (this.products) ? this.products.discount : null,
            icon: 'fas fa-money-bill-wave info-tool'
          }
        ]
      }
    }
  },
  async created () {
    this.priceCategoryes = ProductsService.getPriceCategories()
    await this.getProduct()
    await this.getManufacturers()
  }
}
</script>
